import React from 'react';
import styled from 'styled-components/macro';
import { ResourceStrings } from '../../../ResourceStrings';
import { Icon } from '@fluentui/react/lib/Icon';
import { forMinWidth } from '../../../theme/breakpoints';
import { ReportFeedbackGuidance } from '../../../config/spaces/spaceConfig';

export interface GoodReportInstructionsProps {
    forSuggestion: boolean;
    additionalGuidance?: ReportFeedbackGuidance;
}

export default function GoodReportInstructions({ forSuggestion, additionalGuidance }: GoodReportInstructionsProps): JSX.Element {
    return (<>
        <Panel>
            <section className={`good-report-instructions ${additionalGuidance && 'has-additional-guidance'}`}>
                <InstructionsTile
                    iconName="FolderSearch"
                    title="Search First"
                    description="Search, vote and comment on the duplicate problem to save time on reporting a new problem."
                />
                <InstructionsTile
                    iconName="EntitlementRedemption"
                    title={ResourceStrings.guideClearTitle()}
                    description={ResourceStrings.guideProvideClearTitles()}
                />
                <InstructionsTile
                    iconName="ReopenPages"
                    title={forSuggestion ? ResourceStrings.guideSeparateIdeas() : ResourceStrings.guideSeparateIssues()}
                    description={forSuggestion ? ResourceStrings.guideIfYouHaveMultipleSuggestions() : ResourceStrings.guideIfYouHaveMultipleProblems()}
                />
                {additionalGuidance && <InstructionsTile
                    iconName={additionalGuidance.iconName}
                    title={additionalGuidance.title}
                    // eslint-disable-next-line react/no-danger
                    description={<span dangerouslySetInnerHTML={{ __html: additionalGuidance.description }} />}
                />}
            </section>
        </Panel>

        <div css="border-bottom: solid 1px var(--color-on-surface-lighter); margin: 0 -3.5rem" />
    </>);
}

interface InstructionsTileProps {
    iconName: string;
    title: string;
    description: string | JSX.Element;
}

const InstructionsTile = (props: InstructionsTileProps): JSX.Element => (
    <InstructionsTileWrapper>
        <span className="icon-col">
            <Icon iconName={props.iconName} />
        </span>
        <span>
            <h3>{props.title}</h3>
            <div>{props.description}</div>
        </span>
    </InstructionsTileWrapper >
)

const InstructionsTileWrapper = styled.article`
    display: flex;
    flex-direction: row;
    min-height: 8rem;
    font-size: 1.4rem;
    padding: 0 1rem;
    align-items: flex-start;
    text-align: left;
    max-width: 30rem;

    ${forMinWidth.lg`
        flex-direction: column;

        align-items: center;
        text-align: center;
    `}

    i {
        width: 5rem;
        height: 5rem;
        font-size: 2.4rem;
        line-height: 2.8rem;
        background-color: var(--color-primary);
        color: var(--color-on-surfacedark);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 1.5rem;
    }

    h3 {
        font-size: 1.8rem;
        font-weight: 600;
    }
`;

const Panel = styled.section`
    .good-report-instructions {
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        ${forMinWidth.lg`
            flex-direction: row;
        `}
    }
`;
